<template>
  <el-container>
    <el-header>
      <el-row type="flex" align="middle">
        <el-col style="line-height: 60px;">
          <el-button round @click="onRefersh">{{generateCustomizeString('refresh')}}</el-button>
          <el-button round @click="createClick">{{generateCustomizeString('add')}}</el-button>
          <el-popover
            placement="bottom"
            :title="generateCustomizeString('agentApplicationUrl')"
            width="300"
            trigger="click">
            <div style="text-align: center;">
              <a :href="agentAdminUrl + 'application?' + this.shopIdBase64" target="_blank" style="text-decoration:underline; color: #409EFF;">{{ agentAdminUrl + 'application?' + this.shopIdBase64 }}</a>
            </div>
            <el-button round slot="reference" @click="agentApplication" style="margin-left: 10px;">{{generateCustomizeString('agentApplication')}}</el-button>
          </el-popover>
          <el-tag style="margin-left: 10px;">{{ generateCustomizeString('defaultAgentLoginURL') }}
            <a :href="agentAdminUrl" target="_blank">{{agentAdminUrl}}</a>
          </el-tag>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <el-table :data="agentData" v-loading="loading" style="width: 100%; margin-bottom:60px;">
        <el-table-column :label="generateCustomizeString('shopLogo')">
          <template slot-scope="scope">
            <img
              v-if="scope.row.shopLogo"
              :src="scope.row.shopLogo + '?imageView2/1/w/200/h/200/q/75|imageslim'"
              class="shop-logo"
              align="center"
            >
          </template>
        </el-table-column>
        <el-table-column prop="shopName" :label="generateCustomizeString('shopName')"></el-table-column>
        <el-table-column prop="shopUrl" :label="generateCustomizeString('shopURL')"></el-table-column>
        <el-table-column prop="contactPerson" :label="generateCustomizeString('contactPerson')"></el-table-column>
        <el-table-column :label="generateCustomizeString('digitalWallet')">
          <template slot-scope="scope">
            <span>{{ scope.row.balance }}</span>
            <el-button
              type="text"
              size="small"
              @click="viewAgentDigitalWallet(scope.row)"
            >{{ generateCustomizeString('view') }}</el-button>
          </template>
        </el-table-column>
        <el-table-column prop="active" :label="generateCustomizeString('active')" align="center">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.activity"
              :active-value="1"
              :inactive-value="0"
              @change="editAgentStatus(scope)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column fixed="right" :label="generateCustomizeString('operate')">
          <template slot-scope="scope">
            <el-button
              @click="editClick(scope.row)"
              type="text"
              size="small"
            >{{generateCustomizeString('edit')}}</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer style="position: fixed; bottom: 0; width: 100%; z-index:9999; padding-top:10px;">
      <el-row type="flex">
        <el-col style="padding-top: 5px;">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="numOfAgents"
            layout="total, prev, pager, next"
            :total="currentTotal"
          ></el-pagination>
        </el-col>
        <!-- <el-col>
          <div style="position: fixed; right: 30px;">
            <span style="font-size: 14px; color: #606266;">每页会员数：</span>
            <el-select v-model="numOfAgents" style="width: 100px;" @change="selectNumOfMembers()">
              <el-option
                v-for="item in numOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </el-col>-->
      </el-row>
    </el-footer>
  </el-container>
</template>

<script>
import { generateCustomizeString } from '@/utils/i18n'
import request from '@/utils/request'
import { Base64 } from 'js-base64'

const agentSearchForm = {
  merchant_contact_email: '',
  display_shop_name: '',
  merchant_contact_phone: '',
  wechat_id: ''
}

export default {
  name: 'AgentList',
  components: {},
  data() {
    return {
      agentAdminUrl: process.env.VUE_APP_AGENT_URL,
      loading: false,
      agentData: [],
      agentListLoading: false,
      currentPage: 1,
      currentTotal: 0,
      numOfAgents: 15,
      numOptions: [
        {
          value: 15,
          label: '15'
        },
        {
          value: 50,
          label: '50'
        },
        {
          value: 100,
          label: '100'
        }
      ],
      shopIdBase64: '',
      searchForm: Object.assign({}, agentSearchForm)
    }
  },
  computed: {
    viewActived() {
      return this.$store.state.tagsView.changedViewEvent
    }
  },
  watch: {
    viewActived: function(newValue) {
      this.onRefersh()
    }
  },
  methods: {
    generateCustomizeString,
    onRefersh() {
      this.fetchAgentList(this.currentPage)
    },
    createClick() {
      this.$router.push({ name: 'CreateAgent' })
    },
    editClick(row) {
      this.$router.push({
        name: 'EditAgent',
        params: { agentId: row.id }
      })
    },
    fetchAgentList(page) {
      return new Promise((resolve, reject) => {
        this.loading = true
        request({
          url: '/agent/list',
          method: 'get',
          params: {
            page: page,
            ...this.filters,
            page_size: this.numOfAgents
          }
        })
          .then(response => {
            const data = response.data
            const meta = response.meta
            for (let i = 0; i < response.data.length; i++) {
              var obj = {}
              var tmpAgent = response.data[i]
              obj.id = tmpAgent.id
              // obj.digitalWallet = this.fetchAgentWallet(obj.id)
              obj.shopName = tmpAgent.display_shop_name
              obj.shopUrl = process.env.VUE_APP_MOBILE_URL + tmpAgent.shop_domain_prefix + '/home'
              if (location.href.includes('ieshop.co.nz')) {
                if (obj.shopUrl.includes('nzmai.com.cn')) {
                  obj.shopUrl = 'https://m.ieshop.co.nz/m/' + tmpAgent.shop_domain_prefix + '/home'
                }
              }
              obj.contactPerson = tmpAgent.admin.username
              obj.activity = tmpAgent.activity
              obj.balance =
                'NZD $' + parseFloat(tmpAgent.wallet.balance / 100).toFixed(2)
              if (response.data[i].shop_logo_url) {
                obj.shopLogo = response.data[i].shop_logo_url
              }

              data[i] = obj
            }
            console.log(data)
            this.agentData = data
            this.currentPage = meta.current_page
            this.currentTotal = meta.total
            resolve()
          })
          .catch(error => {
            console.warn(error)
            reject(error)
          })
          .finally(() => {
            this.loading = false
          })
      })
    },
    editAgentStatus(scope) {
      request({
        url: 'agent/' + scope.row.id,
        method: 'patch',
        data: {
          activity: this.agentData[scope.$index].activity
        }
      })
        .then(res => {
          if (res.status === 0) {
            this.$message({
              message: this.generateCustomizeString('updateSuccessfully'),
              type: 'success'
            })
          }
        })
        .catch(error => {
          console.error(error)
          this.$message.error(this.generateCustomizeString('updateFailed'))
        })
    },
    viewAgentDigitalWallet(row) {
      this.$router.push({
        name: 'DigitalWallet',
        params: { agentId: row.id }
      })
    },
    handleCurrentChange(val) {
      this.fetchAgentList(val)
    },
    agentApplication() {
      this.shopIdBase64 = encodeURIComponent(Base64.encode(this.$store.state.user.shop_id))
    }
  },
  created: function() {
    if (location.host.includes('ieshop.co.nz')) {
      if (this.agentAdminUrl.includes('nzmai.com.cn')) {
        this.agentAdminUrl = 'https://agent.ieshop.co.nz'
      }
    }

    this.fetchAgentList(this.currentPage)
  }
}
</script>

<style scoped>
.shop-logo {
  max-width: 40%;
  max-height: 40%;
}
</style>

<style rel="stylesheet/scss" lang="scss" scoped>
.el-header,
.el-footer {
  background-color: #eee;
  color: #333;
}
</style>
